import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import "../../../_metronic/_assets/sass/components/Announcements/Announcements.scss";

import React from "react";
import {
  CalendarTodayOutlined,
  FavoriteBorderOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";
import { getTypeIcon } from "./CardViewContentStaff";
import { useSelector } from "react-redux";

const CardViewAnnouncements = ({
  anncs,
  openDialog,
  deleteAnnc,
  handleOpenNotificationModal,
}) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <Grid container spacing={2} style={{ padding: "30px 30px" }}>
      {anncs.data &&
        anncs.data.map((annc) => {
          return (
            <Grid
              item
              key={annc.id}
              xs={12}
              sm={6}
              md={6}
              lg={3}
              xl={2}
              style={{ minHeight: "100% !important" }}
            >
              <Card
                style={{ margin: "5px" }}
                className="card-item-announcements"
              >
                <CardActionArea id="edit_announce_card_action">
                  <CardContent onClick={() => openDialog("editing", annc.id)}>
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "50px",
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "10%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {getTypeIcon(annc.file_type)}
                      </div>
                      <div style={{ width: "90%" }}>
                        <Typography
                          variant="h5"
                          style={{
                            fontWeight: "600",
                            fontSize: "20px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {annc.title}
                        </Typography>
                      </div>
                    </div>

                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.25rem",
                        marginBottom: 10,
                      }}
                    >
                      <div class="flex items-center gap-2 text-sm text-zone-gray-medium dark:text-zone-gray-light">
                        <CalendarTodayOutlined />
                        <span style={{ marginLeft: 10 }}>
                          Sent: {annc.created_at_str}
                        </span>
                      </div>
                    </Typography>

                    <div style={{ display: "flex", marginBottom: 10 }}>
                      <div>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{ fontSize: "15px", lineHeight: "1.25rem" }}
                        >
                          <div class="flex items-center gap-1 text-sm text-zone-gray-medium dark:text-zone-gray-light">
                            <VisibilityOutlined />
                            <span style={{ marginLeft: 10 }}>
                              {annc.read} read
                            </span>
                          </div>
                        </Typography>
                      </div>
                      <div>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{ fontSize: "15px", lineHeight: "1.25rem" }}
                        >
                          <div class="flex items-center gap-1 text-sm text-zone-gray-medium dark:text-zone-gray-light">
                            <FavoriteBorderOutlined
                              style={{ marginLeft: 10 }}
                            />
                            <span>{annc.liked} liked</span>
                          </div>
                        </Typography>
                      </div>
                    </div>
                    {annc.teams && annc.teams.length > 0 && (
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontSize: "15px", lineHeight: "1.25rem" }}
                      >
                        <span style={{ fontSize: "12px", marginBottom: 3 }}>
                          Sent to:
                        </span>
                        <div
                          class="flex flex-wrap gap-1"
                          style={{ display: "flex" }}
                        >
                          {annc.teams.map((e, index) => (
                            <div key={index} className="custom-badge">
                              {e.name}
                            </div>
                          ))}
                        </div>
                      </Typography>
                    )}
                  </CardContent>
                  <CardActions>
                    <Grid container item xs={12} spacing={1}>
                      <Grid item xs={12} md={user.is_admin ? 12 : 10}>
                        <button
                          onClick={() => openDialog("editing", annc.id)}
                          className="btn-actions-card-announcements"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-square-pen w-3 h-3 mr-1"
                          >
                            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path>
                          </svg>
                          <span style={{ marginLeft: "10px !important" }}>
                            Edit
                          </span>
                        </button>
                      </Grid>
                      {!user.is_admin && (
                        <Grid item xs={12} md={2}>
                          <button
                            onClick={() => deleteAnnc(annc.id)}
                            className="btn-actions-card-announcements btn-actions-red"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trash2 w-3 h-3"
                            >
                              <path d="M3 6h18"></path>
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                              <line x1="10" x2="10" y1="11" y2="17"></line>
                              <line x1="14" x2="14" y1="11" y2="17"></line>
                            </svg>
                          </button>
                        </Grid>
                      )}
                    </Grid>
                  </CardActions>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default CardViewAnnouncements;
